import AOS from 'aos';


function scrollHeader() {
    const header = document.querySelector('.header__nav');
 
    if (header.length > 0) {
        document.addEventListener('scroll', () => {
        window.pageYOffset > 50
            ? header.classList.add('header__nav--scrolled')
            : header.classList.remove('header__nav--scrolled');
        })
    }
}

function toggleMenu() {
    if ($(window).width() < 1024) {
        const menu = $('.menu');
        const hamburger = $('.hamburger')
        menu.append($('.header__top'));

        function hideMenu() {
            hamburger.removeClass('is-open');
            menu.removeClass('is-open');
            $('body').removeClass('is-open');
            $('.overlay').fadeOut(500);
        }

        hamburger.on('click', function() {
            hamburger.toggleClass('is-open');
            menu.toggleClass('is-open');
            $('body').toggleClass('is-open');
            $('.overlay').fadeToggle(500);
        })

        $('.overlay, .menu a').on('click', function() {
            hideMenu();
        })
    }
}


function cookies() {
    let agree = localStorage.getItem('cookie_agree');
    let container = document.querySelector('.cookies');
    if (agree) {
        if (container) container.style.display = 'none';
    } else {
        container.style.display = 'block';
        let btn = document.querySelector('#close-cookies');

        if (btn) {
            btn.addEventListener('click', e => {
                e.preventDefault();
                localStorage.setItem('cookie_agree', true);

                if (container) container.style.display = 'none';
            });
        }
    }
}

function addAosAttributes() {
    let classNames = ['.fade-right, .fade-left, .fade-up, .fade-down, .fade-columns'];
    let animatedElems = document.querySelectorAll(classNames);
    let fadeColumnsCounter = 1;

    if (animatedElems.length) {
        animatedElems.forEach((item, index) => {

            if (item.classList.contains('fade-right')) {
                item.setAttribute('data-aos', 'fade-right');
            } else if (item.classList.contains('fade-left')) {
                item.setAttribute('data-aos', 'fade-left');
            } else if (item.classList.contains('fade-up')) {
                item.setAttribute('data-aos', 'fade-up');
            } else if (item.classList.contains('fade-down')) {
                item.setAttribute('data-aos', 'fade-down');
            } else if (item.classList.contains('fade-columns')) {
                if (item.previousElementSibling) {
                    fadeColumnsCounter++;
                }
                item.setAttribute('data-aos', 'fade-up');
                item.setAttribute('data-aos-delay', 150 * fadeColumnsCounter);

                if (!item.nextElementSibling) {
                    fadeColumnsCounter = 1;
                }
            }

            if (animatedElems.length == (index + 1)) {
                setTimeout(() => {
                    AOS.init({
                        once: true,
                        duration: 700,
                        easing: 'ease-out',
                        throttleDelay: 200,
                        offset: 100,
                        disable: 'mobile',
                    });
                }, 500);
            }
        });
    } else {
        setTimeout(() => {
            AOS.init({
                throttleDelay: 200,
                offset: 100,
                once: true,
                duration: 300,
                easing: 'ease-out',
                disable: 'mobile',
            });
        }, 500);
    }
}


// ANALYTICS
function analyticEvent(type, name) {
    console.log(`fbq( 'track', '${type}', {\n    content_name: '${name}'\n} )`);
    fbq('track', type, {
        content_name: name
    });
}

function analytics() { 
    // HOME page
    // NervoCalm Forte
    $('#eventNervoCalmForte, .eventNervoCalmForte a').on('click', function() {
        analyticEvent('eventNervoCalmSen', 'All');
    });
    // Kup teraz - Sen
    $('#eventKupTerazNervoCalmSen, .eventNervoCalmSen a').on('click', function() {
        analyticEvent('NervoCalm_Sen', 'All');
    });

    // PRODUCT page
    // Zobacz Spot - Forte
    $('#eventZobaczSpotForte').on('click', function() {
        analyticEvent('ZobaczSpot', 'Forte');
        gtag('event', 'conversion', {
            'send_to': '431500382/lPJzCKa6i_QBEN7Y4M0B'
        });
    });
    // Zobacz Spot - Sen
    $('#eventZobaczSpotSen').on('click', function() {
        analyticEvent('ZobaczSpot', 'Sen');
        gtag('event', 'conversion', {
            'send_to': '431500382/NPHLCP3WnfQBEN7Y4M0B'
        });
    });
    // Pobierz ulotkę - Forte
    $('#eventPobierzUlotkeForte a').on('click', function() {
        analyticEvent('Ulotka', 'Forte');
        gtag('event', 'conversion', {
            'send_to': '431500382/WMMOCIWxqvQBEN7Y4M0B'
        });
    });
    // Pobierz ulotkę - Sen
    $('#eventPobierzUlotkeSen a').on('click', function() {
        analyticEvent('Ulotka', 'Sen');
        gtag('event', 'conversion', {
            'send_to': '431500382/-xhXCIyvqvQBEN7Y4M0B'
        });
    });
    // Dowiedz się więcej - Forte
    $('#eventDowiedzSieWiecejForte a').on('click', function() {
        analyticEvent('Dowiedz_się_Więcej', 'Forte');
    });
    // Dowiedz się więcej - Sen
    $('#eventDowiedzSieWiecejSen a').on('click', function() {
        analyticEvent('Dowiedz_się_Więcej', 'Sen');
    });

    // GDZIE KUPIC page
    // Kup teraz - Forte
    $('#eventKupTerazNervoCalmForte').on('click', function() {
        analyticEvent('KupTeraz', 'Forte');
        gtag('event', 'conversion', {
            'send_to': '431500382/QZguCJu_nfQBEN7Y4M0B'
        });
    });
    // Kup teraz - Sen
    $('#eventKupTerazNervoCalmSen').on('click', function() {
        analyticEvent('KupTeraz', 'Sen');
        gtag('event', 'conversion', {
            'send_to': '431500382/6HlZCNK6nfQBEN7Y4M0B'
        });
    });
    // Sprawdź KtoMaLek.pl
    $('#eventNervoCalmSen').on('click', function() {
        analyticEvent('Sprawdź_KtoMaLek', 'All');
        gtag('event', 'conversion', {
            'send_to': '431500382/gZa9CNyvnfQBEN7Y4M0B'
        });
    });
    // Gdzie kupic - Forte
    $('#eventGdzieKupicForte1 a, #eventGdzieKupicForte2 a, #eventGdzieKupicSen1 a, #eventGdzieKupicSen2 a').on('click', function() {
        gtag('event', 'conversion', {
            'send_to': '431500382/VSBmCMPFqvQBEN7Y4M0B'
        });
    });

    // kod remarketingowy Google Ads - remarketing na kazdej stronie
    gtag('event', 'conversion', {
        'send_to': '431500382'
    });
}


window.addEventListener('resize', () => {
    scrollHeader();
});

document.addEventListener('DOMContentLoaded', () => {
    scrollHeader();
    toggleMenu();
    addAosAttributes();
    cookies();
    analytics();
})



//////////////////
// WEBPACK FOOTER
// ./js/script.js
// module id = 2
// module chunks = 0